module.exports = __webpack_public_path__ + "img/ptss.309db045.png";